import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import CommissionCalculator from '../affiliate-dashboard/components/CommissionCalculator';
import ReferralLinkManager from '../affiliate-dashboard/components/ReferralLinkManager';
import MarketingTools from '../affiliate-dashboard/components/MarketingTools';
import WithdrawalManager from '../affiliate-dashboard/components/WithdrawalManager';
import Icon from '../../components/AppIcon';


const AffiliateManagement = () => {
  const navigate = useNavigate();

  const mockUser = {
    type: 'user',
    membershipTier: 'Elite',
    notifications: {
      dashboard: 3,
      affiliate: 5
    }
  };

  const mockEarningsData = {
    totalEarnings: 450000,
    totalWithdrawn: 850000,
    totalPoints: 780,
    withdrawalEligible: true,
    withdrawalMinimum: 200000
  };

  const mockReferralLink = "https://bizznet.com/ref/user123456";

  const mockClickAnalytics = {
    totalClicks: 342,
    clicksThisWeek: 47,
    conversions: 35,
    conversionRate: 10.2,
    uniqueClicks: 298,
    uniqueRate: 87.1
  };

  const mockPendingWithdrawals = [
    {
      id: "WTH001",
      amount: 200000,
      date: "28/11/2025",
      method: "Nequi",
      status: "processing"
    },
    {
      id: "WTH002",
      amount: 150000,
      date: "20/11/2025",
      method: "Bancolombia",
      status: "approved"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header user={mockUser} />
      <main className="main-content">
        <div className="max-w-7xl mx-auto py-8 space-y-8">
          {/* Breadcrumb Navigation */}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <button
              onClick={() => navigate('/affiliate-dashboard')}
              className="hover:text-primary transition-colors flex items-center gap-1"
            >
              <Icon name="ArrowLeft" size={16} />
              <span>Panel de Afiliados</span>
            </button>
            <Icon name="ChevronRight" size={16} />
            <span className="text-foreground font-medium">Gestionar Afiliados</span>
          </div>

          {/* Page Header */}
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-foreground mb-2">Gestionar Afiliados</h1>
              <p className="text-muted-foreground">Herramientas avanzadas para maximizar tus ganancias</p>
            </div>
          </div>

          {/* Commission Calculator */}
          <CommissionCalculator />

          {/* Referral Link Manager */}
          <ReferralLinkManager
            referralLink={mockReferralLink}
            clickAnalytics={mockClickAnalytics}
          />

          {/* Marketing Tools */}
          <MarketingTools />

          {/* Withdrawal Manager */}
          <WithdrawalManager
            availableBalance={mockEarningsData?.totalEarnings}
            minimumWithdrawal={mockEarningsData?.withdrawalMinimum}
            pendingWithdrawals={mockPendingWithdrawals}
          />
        </div>
      </main>
    </div>
  );
};

export default AffiliateManagement;